import { lazy } from 'react';

const PersonalCardsSettingsPage = lazy(() => import('@/pages/Settings/PersonalCardsSettingsPage'));

export const personalCardsRoutes = [
  {
    path: "/personal-cards-settings",
    element: PersonalCardsSettingsPage,
    meta: {
title: "Personalized Landing Pages Settings",
    description: "Configure personalized landing pages logo and appearance"
    },
    requiresAuth: true
  }
];
